import useJsDate from 'app/hooks/js-date';
import { patchChildJournal, postChildJournal } from 'child-journals/api';
import ChildJournalForm from 'child-journals/new/form';
import { Formik } from 'formik';
import useSWR from 'swr';
import { object, date, string } from 'yup';
import useEntity from 'entities/hooks/use-entity';
import React, { useEffect, useState } from 'react';
import { Text, Flex } from 'rebass';
import { getSWR, patch, prepareAttrs } from 'utils/api';
import useMatch from 'app/hooks/match';
import useEntityActionCreators from 'entities/hooks/use-entity-action-creators';
import Wrapper from 'gift-certificate/Wrapper';
import useCreateCover from 'collections/hooks/create-cover';
import useCurrentMemberId from 'members/hooks/index';

const BabyDetails = ({ onStepUp, attributes, setChildJournalId, renderheader, setChildJournalDetails, journalId, onStepDown, onLoginPress, redeemCode }) => {
    const { params } = useMatch();
    const [isSubmitting, setIsSubmitting] = useState(false)
    const subjectRelation = "Child"
    const isChildRelation = subjectRelation === "Child"
    let { entity: childJournal } = useEntity({ type: 'child-journals', id: params?.id || journalId });
    const createCover = useCreateCover();
    const memberId = useCurrentMemberId();

    useSWR(`/v2/members/${memberId}/identifiers`, getSWR, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
    });

    if (!childJournal || !Object.keys(childJournal).length)
        childJournal = attributes;

    const initialDate = useJsDate(childJournal?.['date-of-birth']);
    const { receive } = useEntityActionCreators();

    // const createNewJournal = async () => {
    //     const body = {
    //         data: {
    //             attributes: {},
    //         },
    //     };

    //     let cjRes = null

    //     if (redeemCode)
    //         await patch(`/v3/commerce/gift_certificates/${redeemCode}/claim`)

    //     cjRes = await postChildJournal(body);
    //     const [id] = cjRes.data.result['child-journals'];
    //     if (redeemCode) {
    //         cjRes = await patch(`v3/child_journals/${id}/redeem_gift_certificate`)
    //     }
    //     store.set('child_journal_id', id)
    //     // receive({ payload: cjRes });
    //     setChildJournalId(id)
    // }

    // useEffect(() => {
    //     if (!journalId)
    //         createNewJournal()
    // }, [journalId]);

    const initialValues = {
        'first-name-noac': (childJournal && childJournal?.['first-name']) || '',
        // 'date-of-birth': initialDate || undefined,
        gender: childJournal?.gender || '',
        // cover: '',
        // 'subject-pronoun': (childJournal && childJournal['subject-pronoun']) || ''
    };

    const validationSchema = object().shape({
        'first-name-noac': string().required('Name is required'),
        // 'date-of-birth': date().required('Date of Birth is required'),
        gender: string().required('Gender is required'),
        // 'subject-pronoun': string().required('Pronoun is required'),
    });

    const isInitialValid = validationSchema.isValidSync(initialValues);

    async function onSubmit({ cover, ...values }) {
        const attributes = prepareAttrs(values);
        // attributes['subject-relation'] = 'Child';
        // if (!values['first-name-noac'])
        //     attributes['first-name'] = 'Baby';

        setIsSubmitting(true)
        const body = {
            data: {
                attributes,
            },
        };
        let cjRes = null

        if (journalId) {
            cjRes = await patchChildJournal({ id: journalId, ...attributes });
        }
        else
            cjRes = await postChildJournal(body);


        const [id] = cjRes.data.result['child-journals'];
        if (cover instanceof Blob) {
            await createCover({ id, type: 'child-journals', cover });
        }
        if (redeemCode) {
            cjRes = await patch(`v3/child_journals/${id}/redeem_gift_certificate`)
        }

        receive({ payload: cjRes });
        // setChildJournalDetails
        setChildJournalId(id)
        onStepUp(id)
        setIsSubmitting(false)

    }

    return (
        <Formik
            {...{ initialValues, validationSchema, isInitialValid }}
            enableReinitialize
            onSubmit={onSubmit}
        >
            {({ values, handleSubmit }) => (
                <Wrapper
                    hideSkip={false}
                    renderheader={renderheader}
                    isSubmitting={isSubmitting}
                    // onHideSkip={async () => {
                    //     // setIsSubmitting(true)
                    //     // if (redeemCode)
                    //     //     await patch(`/v3/commerce/gift_certificates/${redeemCode}/claim`)
                    //     if (!values['first-name-noac']) {

                    //         // if (redeemCode)
                    //         //     await patch(`/v3/commerce/gift_certificates/${redeemCode}/claim`)

                    //         if (journalId) {
                    //             const cjRes = await patchChildJournal({
                    //                 id: journalId,
                    //                 ...{
                    //                     'first-name': 'Baby',
                    //                 }
                    //             });
                    //             receive({ payload: cjRes });
                    //         }
                    //     }

                    //     // if (redeemCode) {
                    //     //     cjRes = await patch(`v3/child_journals/${journalId}/redeem_gift_certificate`)
                    //     // }
                    //     // setIsSubmitting(false)
                    //     onStepUp(journalId)
                    // }}
                    onSubmit={handleSubmit}
                    showFooter
                    onBack={onStepDown}
                    percentComplete={0}
                    bg="aliceBlue"
                    nextButtonText={isSubmitting ? 'Starting your book' : 'Continue'}
                >
                    <Flex p={2} flexDirection="column" m="auto" maxWidth={700} height={['auto', '100vh']}>
                        <Text
                            color="codGrey"
                            textAlign="left"
                            fontFamily="Bitter"
                            fontSize={30}
                            lineHeight={"120%"}
                            letterSpacing="-0.18px"
                            mt={2}
                            fontWeight={600}
                            mb={1}
                        >
                            {isChildRelation ? 'About your baby' : 'What a thoughtful gift – They’ll Love It!'}
                        </Text>
                        <Text
                            color="#64748B"
                            textAlign="left"
                            fontFamily="Poppins"
                            fontSize={16}
                            lineHeight={["20px", "28px"]}
                            letterSpacing="-0.18px"
                            my={3}
                        >
                            {isChildRelation ? 'Let’s start creating your book. You can always edit this later.' : "We'll email you a gift card that you can forward and/or print for your gift recipient."}
                        </Text>
                        <ChildJournalForm />
                    </Flex>
                </Wrapper>
            )}
        </Formik>

    );
};

export default BabyDetails;
